import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const DefaultMarketingPage = loadable(() => import('./DefaultMarketingPage'));

DefaultMarketingPage.getInitialState = getInitialState;

export default DefaultMarketingPage;
